/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CoreMetadataDto
 */
export interface CoreMetadataDto {
    /**
     *
     * @type {string}
     * @memberof CoreMetadataDto
     */
    metadata?: string;
}

/**
 * Check if a given object implements the CoreMetadataDto interface.
 */
export function instanceOfCoreMetadataDto(
    value: object,
): value is CoreMetadataDto {
    return true;
}

export function CoreMetadataDtoFromJSON(json: any): CoreMetadataDto {
    return CoreMetadataDtoFromJSONTyped(json, false);
}

export function CoreMetadataDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CoreMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        metadata: json["metadata"] == null ? undefined : json["metadata"],
    };
}

export function CoreMetadataDtoToJSON(value?: CoreMetadataDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        metadata: value["metadata"],
    };
}
